import { Navigate, Outlet } from "react-router-dom";
import { useAuthStore } from "../../zustand/ZustandContext";

const LoginRedirect = () => {
    const auth = useAuthStore((state) => state.auth);

    // Si ya está autenticado, redirige al dashboard
    if (auth) {
        return <Navigate to="/inicio" replace />;
    }

    return <Outlet />;
};

export default LoginRedirect;
